import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchBoxModule } from '@jms/ui/ui.search.box';
import { ShellDialogService } from '@jms/ui/ui.shell.dialog.service';

import { AppointmentEditorModule } from '../editor';
import { AppointmentViewModule } from '../view';
import { AppointmentDashboardComponent } from './components';
import { SearchComponent } from '@workbuddy/ui/fields/search';
import { ButtonComponent } from '@workbuddy/ui/components/button';

@NgModule({
  declarations: [
    AppointmentDashboardComponent
  ],
  imports: [
    CommonModule,

    AppointmentEditorModule,
    AppointmentViewModule,

    SearchBoxModule,

    DynamicDialogModule,
    SearchComponent,
    ButtonComponent,
  ],
  providers: [
    ShellDialogService,
  ],
  exports: [
    AppointmentDashboardComponent
  ]
})
export class AppointmentsModule { }
